// mutations
const RESTAURANT_REPORTS_ALL = (state, restaurantReports) => {
  if (restaurantReports.code === 1) {
    state.restaurantReports = restaurantReports.data
    state.status = 'success'
  } else {
    alert(restaurantReports.message)
    state.status = 'error'
  }
}

const RESTAURANT_REPORTS_FORM = (state, restaurantReports) => {
  if (restaurantReports.code === 1) {
    state.restaurantReports = restaurantReports.data
    state.status = 'success'
  } else {
    alert(restaurantReports.message)
    state.status = 'error'
  }
}

const RESTAURANT_REPORTS_SHOW = (state, restaurantReports) => {
  if (restaurantReports.code === 1) {
    state.restaurantReports = restaurantReports.data
    state.status = 'success'
  } else {
    alert(restaurantReports.message)
    state.status = 'error'
  }
}

const RESTAURANT_REPORTS_CREATE = (state, restaurantReports) => {
  if (restaurantReports.code === 1) {
    state.restaurantReports = restaurantReports.data
    state.status = 'success'
  } else {
    alert(restaurantReports.message)
    state.status = 'error'
  }
}

const RESTAURANT_REPORTS_UPDATE = (state, restaurantReports) => {
  if (restaurantReports.code === 1) {
    state.restaurantReports = restaurantReports.data
    state.status = 'success'
  } else {
    alert(restaurantReports.message)
    state.status = 'error'
  }
}

const RESTAURANT_REPORTS_DELETE = (state, restaurantReports) => {
  if (restaurantReports.code === 1) {
    state.restaurantReports = restaurantReports.data
    state.status = 'success'
  } else {
    alert(restaurantReports.message)
    state.status = 'error'
  }
}

export default {
  RESTAURANT_REPORTS_ALL,
  RESTAURANT_REPORTS_FORM,
  RESTAURANT_REPORTS_SHOW,
  RESTAURANT_REPORTS_CREATE,
  RESTAURANT_REPORTS_UPDATE,
  RESTAURANT_REPORTS_DELETE
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/reports/mutations.js